export function getDevicePlatform() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isAndroid = /android/i.test(userAgent);

  if (isIOS) return "ios";
  if (isAndroid) return "android";
  return "other";
}

export function getStoreUrlForDevice(appStoreUrl, playStoreUrl) {
  const platform = getDevicePlatform();

  if (platform === "ios" && appStoreUrl) return appStoreUrl;
  if (platform === "android" && playStoreUrl) return playStoreUrl;
  return null;
}

const CRAWLER_RE =
  /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandex|facebookexternalhit|facebot|twitterbot|linkedinbot|slackbot|discordbot|pinterest|applebot|semrush|ahrefs|bytespider|gptbot|chatgpt|claudebot|perplexity|ia_archiver/i;

const SEARCH_HOST_RE =
  /(^|\.)google\.|(^|\.)bing\.|(^|\.)duckduckgo\.|(^|\.)yahoo\.|(^|\.)yandex\.|(^|\.)baidu\.|(^|\.)ecosia\.|(^|\.)brave\.com/i;

export function isKnownCrawler() {
  const ua = navigator.userAgent || "";
  return CRAWLER_RE.test(ua);
}

function referrerHost() {
  const ref = document.referrer || "";
  if (!ref) return "";
  try {
    return new URL(ref).hostname.replace(/^www\./, "").toLowerCase();
  } catch {
    return "";
  }
}

export function arrivedFromSearch() {
  return SEARCH_HOST_RE.test(referrerHost());
}

export function arrivedFromThisSite() {
  const host = referrerHost();
  return host === "mindblows.com" || host.endsWith(".mindblows.com");
}

/**
 * Instant store-open for in-app share links that already point at
 * /apps/<slug>, without bouncing Google clicks or site browsing.
 */
export function shouldAutoOpenStore() {
  if (typeof window === "undefined") return false;
  if (isKnownCrawler()) return false;

  const params = new URLSearchParams(window.location.search);
  if (params.get("stay") === "1" || params.get("nogo") === "1") return false;
  if (params.get("go") === "1" || params.get("store") === "1") {
    return getDevicePlatform() !== "other";
  }

  if (arrivedFromSearch() || arrivedFromThisSite()) return false;

  const platform = getDevicePlatform();
  return platform === "ios" || platform === "android";
}
